// ru translations — extracted mechanically from LanguageContext.jsx (Team Foundation).
// Feature-specific keys belong in src/i18n/extensions/*.js instead.
const ru = {
    // Common
    "common.loading": "Загрузка...",
    "common.save": "Сохранить",
    "common.cancel": "Отмена",
    "common.delete": "Удалить",
    "common.edit": "Редактировать",
    "common.submit": "Отправить",
    "common.logout": "Выйти",
    "common.login": "Войти",
    "common.register": "Регистрация",
    
    // Auth
    "auth.welcome": "Добро пожаловать",
    "auth.signIn": "Войдите в свой аккаунт",
    "auth.email": "Электронная почта",
    "auth.password": "Пароль",
    "auth.loginButton": "Войти",
    
    // Navigation
    "nav.dashboard": "Панель",
    "nav.releases": "Релизы",
    "nav.payouts": "Выплаты",
    "nav.support": "Поддержка",
    "nav.referrals": "Рефералы",
    "nav.profile": "Профиль",
    
    // Dashboard
    "dashboard.welcome": "Добро пожаловать",
    "dashboard.subtitle": "Управляйте своей музыкой, отслеживайте релизы и просматривайте доходы.",
    "dashboard.totalReleases": "Всего Релизов",
    "dashboard.totalTracks": "Всего Треков",
    "dashboard.balance": "Текущий Баланс",
    "dashboard.withdrawable": "Доступно для вывода",
    "dashboard.recentReleases": "Последние Релизы",
    "dashboard.newRelease": "Новый Релиз",
    "dashboard.requestPayout": "Запросить Выплату",
    
    // Analytics
    "analytics.title": "Статистика",
    "analytics.subtitle": "Отслеживайте эффективность ваших релизов",
    "analytics.totalStreams": "Всего Прослушиваний",
    "analytics.listeners": "Слушатели",
    "analytics.estimatedEarnings": "Расчетный Доход",
    "analytics.monthlyGrowth": "Месячный Рост",
    "analytics.streamsChart": "График Прослушиваний",
    "analytics.platformDistribution": "Распределение по Платформам",
    "analytics.topTracks": "Популярные Треки",
    "analytics.trackName": "Название Трека",
    "analytics.streams": "прослушиваний",
    "analytics.comingSoonTitle": "Скоро Будет",
    "analytics.comingSoonDesc": "Подробная аналитика и статистика скоро будет доступна. С интеграцией artist.tools вы сможете отслеживать все данные платформ в одном месте.",
    "common.comingSoon": "Скоро",
    
    // Payouts
    "payouts.title": "Управляйте Своими Доходами",
    "payouts.subtitle": "Легко выводите свои музыкальные доходы. Запросите выплату от $50.",
    "payouts.fastPayment": "Быстрая оплата",
    "payouts.secureTransfer": "Безопасный перевод",
    "payouts.totalBalance": "Общий Баланс",
    "payouts.withdrawableBalance": "Доступно для вывода",
    "payouts.requestPayout": "Запросить Выплату",
    "payouts.payoutHistory": "История Выплат",
    "payouts.noPayouts": "Пока нет запросов на выплату",
    "payouts.noPaymentMethod": "Нет Способа Оплаты",
    "payouts.addMethodDesc": "Добавьте способ оплаты для вывода своих доходов.",
    "payouts.addMethod": "Добавить Способ Оплаты",
    "payouts.changeMethodVerification": "Для изменения текущего способа оплаты требуется подтверждение по email",
    "payouts.availableBalance": "Доступный Баланс",
    "payouts.pendingBalance": "Ожидающий Баланс",
    "payouts.withdrawalHistory": "История Выводов",
    "payouts.requestWithdrawal": "Запросить Вывод",
    "payouts.minWithdrawal": "Минимальный вывод: $50",
    "payouts.manageEarnings": "Управляйте своими доходами",
    "payouts.createRequest": "Создать Запрос на Выплату",
    "payouts.amount": "Сумма",
    "payouts.accountHolder": "Владелец Счета",
    "payouts.bankName": "Название Банка",
    "payouts.minAmount": "Минимальная сумма вывода $50",
    "payouts.insufficientBalance": "Недостаточный баланс",
    "payouts.fillRequired": "Пожалуйста, заполните все обязательные поля",
    "payouts.requestCreated": "Запрос на выплату создан",
    "payouts.requestFailed": "Запрос не удался",
    "payouts.minNotMet": "Минимум не достигнут",
    "payouts.minNotMetMsg": "Вам нужно минимум $50 доступного баланса для запроса выплаты.",
    "payouts.statusRequested": "Запрошено",
    "payouts.statusPaid": "Оплачено",
    "payouts.paymentMethod": "Способ Оплаты",
    "payouts.bankTransfer": "Банковский Перевод",
    "payouts.paypalEmail": "Email PayPal",
    "payouts.paypalNote": "Введите email, связанный с вашим аккаунтом PayPal",
    "payouts.fillPaypalRequired": "Пожалуйста, введите email PayPal и имя владельца счета",
    "payouts.selectCountry": "Выберите вашу страну",
    "payouts.tabProfile": "Платежный Профиль",
    "payouts.tabMethod": "Способ Оплаты",
    "payouts.tabRequests": "Запросы на Выплату",
    "payouts.requirements": "Требования для Вывода",
    "payouts.completeProfile": "Заполните платежный профиль (Личность и Адрес)",
    "payouts.addPaymentMethod": "Добавьте способ оплаты (Банк или PayPal)",
    "payouts.verifyPaymentMethod": "Подтвердите способ оплаты",
    "payouts.profileComplete": "Завершено",
    "payouts.savedProfile": "Сохраненная информация профиля",
    "payouts.fullName": "Полное имя",
    "payouts.phoneNumber": "Телефон",
    "payouts.location": "Местоположение",
    "payouts.profileType": "Тип профиля",
    "payouts.individual": "Физическое лицо",
    "payouts.business": "Компания / Бизнес",
    "payouts.edit": "Редактировать",
    
    // Statuses
    "status.draft": "Черновик",
    "status.submitted": "Отправлено",
    "status.approved": "Одобрено",
    "status.rejected": "Отклонено",
    "status.live": "В эфире",
    
    // Validation
    "validation.audioRequired": "Аудиофайл обязателен",
    "validation.audioFormatWav": "Аудиофайл должен быть в формате WAV или FLAC",
    "validation.titleRequired": "Название обязательно",
    "validation.titleLanguageRequired": "Язык названия обязателен",
    "validation.primaryArtistRequired": "Требуется хотя бы один основной исполнитель",
    "validation.primaryGenreRequired": "Выбор основного жанра обязателен",
    "validation.explicitRequired": "Выбор типа контента обязателен",
    "validation.coverRequired": "Обложка обязательна",
    "validation.songwriterRequired": "Требуется хотя бы один автор песен",
    "validation.contributorRequired": "Требуется хотя бы один участник",
    "validation.productionTeamRequired": "Требуется хотя бы один член продюсерской команды",
    "validation.platformRequired": "Необходимо выбрать хотя бы одну платформу",
    "validation.releaseDateRequired": "Дата релиза обязательна",
    "validation.trackCountRequired": "Для EP/Альбома требуется минимум 2 трека",
    "releases.track": "Трек",
    
    // Toast Messages
    "toast.saveSuccess": "Успешно сохранено",
    "toast.saveFailed": "Ошибка сохранения",
    "toast.deleteSuccess": "Успешно удалено",
    "toast.uploadSuccess": "Успешно загружено",
    "toast.submitSuccess": "Успешно отправлено",
    "toast.loginSuccess": "Вход выполнен успешно",
    "toast.copySuccess": "Скопировано в буфер обмена",
    "toast.errorOccurred": "Произошла ошибка",
    "toast.pleaseFixErrors": "Пожалуйста, исправьте ошибки в этом разделе",
    
    // Spotify
    "spotify.comingSoon": "Скоро",
};

export default ru;
